"use strict";

exports.__esModule = true;
exports.actions = void 0;
var actions = {
  SETUP: 'SETUP',
  FIND: 'FIND',
  QUERY: 'QUERY',
  COUNT: 'COUNT',
  BATCH: 'BATCH',
  GET_DELETED_RECORDS: 'GET_DELETED_RECORDS',
  DESTROY_DELETED_RECORDS: 'DESTROY_DELETED_RECORDS',
  UNSAFE_RESET_DATABASE: 'UNSAFE_RESET_DATABASE',
  GET_LOCAL: 'GET_LOCAL',
  SET_LOCAL: 'SET_LOCAL',
  REMOVE_LOCAL: 'REMOVE_LOCAL',
  EXPERIMENTAL_FATAL_ERROR: 'EXPERIMENTAL_FATAL_ERROR',
  CLEAR_CACHED_RECORDS: 'CLEAR_CACHED_RECORDS'
};
exports.actions = actions;